import { RcFile } from 'antd/es/upload'
import { CloseModalFunction, OpenModalFunction } from 'core/modal/redux/types'
import { RTFSettingsTab } from 'modules/operational/rtf/config/sidebar'
import { ClearConfigManagementDataFunction, DownloadConfigManagementFileFunction, File, GetConfigManagementDataFunction, RTFConfigurationManagementState } from 'modules/operational/rtf/redux/configManagement/types'
import { RTFDeviceData } from 'modules/operational/rtf/redux/devices/types'
import { ActivityLogState, CancelCommandFunction, ClearActivityLogStateFunction, GetActivityLogFunction } from 'modules/operational/rtf/redux/logs/activity/types'
import { ClearConfigManagementLogsFunction, ConfigManagementLogsState, GetConfigManagementLogsFunction } from 'modules/operational/rtf/redux/logs/configManagement/types'
import { ClearDownloadURLFunction, GetDownloadURLFunction, GetHistoryFunction, LogsHistoryState } from 'modules/operational/rtf/redux/logs/history/types'
import { ExecuteCommandType, RTFSettings, RunCommandsFunction } from 'modules/operational/rtf/redux/settings/types'
import ActivityLog from './components/ActivityLog'
import ConfigurationManagement from './components/ConfigurationManagement'
import FlushLogs from './components/FlushLogs'
import LogLevels from './components/LogLevels'
import LogProfiles from './components/LogProfiles'
import LogsHistory from './components/LogsHistory'
import './index.scss'

type ContentProps = {
  tab: RTFSettingsTab
  settings: RTFSettings
  device: RTFDeviceData
  openModal: OpenModalFunction
  closeModal: CloseModalFunction
  runCommands: RunCommandsFunction
  executeCommand: ExecuteCommandType
  history: LogsHistoryState
  getHistory: GetHistoryFunction
  getDownloadURL: GetDownloadURLFunction
  clearDownloadURL: ClearDownloadURLFunction
  getActivityLog: GetActivityLogFunction
  activity: ActivityLogState
  cancelCommand: CancelCommandFunction
  clearActivityLogState: ClearActivityLogStateFunction
  configManagement: RTFConfigurationManagementState
  configManagementLogs: ConfigManagementLogsState
  getConfigManagementData: GetConfigManagementDataFunction
  clearConfigManagementData: ClearConfigManagementDataFunction
  downloadConfigManagementFile: DownloadConfigManagementFileFunction
  getConfigManagementUploadLogs: GetConfigManagementLogsFunction
  clearConfigManagementUploadLogs: ClearConfigManagementLogsFunction
  deleteConfigManagementFile: (file: File) => void
  invalidFileUploadToaster: (title: string, message: string) => void
  uploadFile: (file: RcFile) => void
}

export default function Content({
  tab,
  settings,
  device,
  openModal,
  closeModal,
  runCommands,
  executeCommand,
  history,
  getHistory,
  getDownloadURL,
  clearDownloadURL,
  getActivityLog,
  activity,
  cancelCommand,
  clearActivityLogState,
  configManagement,
  configManagementLogs,
  getConfigManagementData,
  clearConfigManagementData,
  downloadConfigManagementFile,
  deleteConfigManagementFile,
  invalidFileUploadToaster,
  uploadFile,
  getConfigManagementUploadLogs,
  clearConfigManagementUploadLogs,
}: ContentProps) {
  switch (tab) {
    case RTFSettingsTab.logProfiles:
      return <LogProfiles
        settings={settings.logProfilesFields}
        closeModal={closeModal}
        connected={device.connected}
        deviceId={device.udid}
        openModal={openModal}
        runCommands={runCommands}
        executeCommand={executeCommand}
      />

    case RTFSettingsTab.logLevels:
      return <LogLevels
        settings={settings.logLevelsFields}
        closeModal={closeModal}
        connected={device.connected}
        deviceId={device.udid}
        openModal={openModal}
        runCommands={runCommands}
        executeCommand={executeCommand}
      />

    case RTFSettingsTab.flushLogs:
      return <FlushLogs
        settings={settings.flushLogsFields}
        closeModal={closeModal}
        connected={device.connected}
        deviceId={device.udid}
        openModal={openModal}
        runCommands={runCommands}
        executeCommand={executeCommand}
      />

    case RTFSettingsTab.configurationManagement:
      return <ConfigurationManagement
        configManagement={configManagement}
        getConfigManagementData={getConfigManagementData}
        clearConfigManagementData={clearConfigManagementData}
        downloadConfigManagementFile={downloadConfigManagementFile}
        deleteConfigManagementFile={deleteConfigManagementFile}
        invalidFileToaster={invalidFileUploadToaster}
        uploadFile={uploadFile}
        getConfigManagementUploadLogs={getConfigManagementUploadLogs}
        clearConfigManagementUploadLogs={clearConfigManagementUploadLogs}
        configManagementLogs={configManagementLogs}
      />

    case RTFSettingsTab.activityLog:
      return <ActivityLog
        deviceId={device.udid}
        activity={activity}
        getActivityLog={getActivityLog}
        cancelCommand={cancelCommand}
        clearActivityLogState={clearActivityLogState}
      />

    case RTFSettingsTab.logsHistory:
      return <LogsHistory
        history={history}
        getHistory={getHistory}
        deviceId={device.udid}
        getDownloadURL={getDownloadURL}
        clearDownloadURL={clearDownloadURL}
      />

    default:
      return <></>
  }
}
